export const APP_TITLE_SUFFIX = "Cursus3";
export const GOOGLE_CLIENT_ID =
  "26160742071-hdopp3l6fmrr0kduos7vk4m6ejq94k2b.apps.googleusercontent.com";
export const REMEMBER_ME = "rememberLogin";
export const SIDEBAR_MODE = {
  DEFAULT: "default",
  DASHBOARD: "dashboard",
  ADMIN: "admin",
};
export const ADMIN_ROLE = "Admin";
export const INSTRUCTOR_ROLE = "Instructor";
export const STUDENT_ROLE = "Student";
export const GUEST_ROLE = "Guest";
export const DATE_FORMAT = "MM/DD/YYYY";
export const EMAIL_VALIDATE =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const SIDEBAR_STATUS = {
  FULL: "FULL",
  MINI: "MINI",
  HIDE: "HIDE",
};
export const TREE_STATUS = {
  COLLAPSE_ALL: "COLLAPSE_ALL",
  EXPAND_ALL: "EXPAND_ALL",
  NORMAL: "NORMAL",
};
export const SECTION_ITEM_TYPE = {
  LECTURE: "LECTURE",
  QUIZ: "QUIZ",
  ASSIGNMENT: "ASSIGNMENT",
};
export const QUIZ_TYPE = {
  SINGLE_CHOICE: 0,
  MULTI_CHOICE: 1,
  SINGLE_LINE: 2,
  MULTI_LINE: 3,
};
export const QUIZ_STATUS = {
  INIT: "INIT",
  DOING: "DOING",
  FINISH: "FINISH",
  REVIEW: "REVIEW",
};
export const DEFAULT_AVATAR =
  "https://i2.wp.com/ui-avatars.com/api/CS/300/ed2a26/fff";
export const DEFAULT_EMPTY_AVATAR =
  "https://i2.wp.com/ui-avatars.com/api/@/300/afafaf";
export const DEFAULT_IMAGE_SRC = "https://www.eduaid.net/site/img/default.png";
export const DEFAULT_IMAGE_SRC_169 =
  "https://via.placeholder.com/800x450/d9d9d9?text=16:9";
export const VIDEO_FALLBACK_169 =
  "https://www.voicesummit.ai/hubfs/video-placeholder.jpg";
export const DEFAULT_IMAGE_SRC_219 =
  "https://via.placeholder.com/1260x450/d9d9d9?text=21:9";
export const DEFAULT_IMAGE_SRC_43 =
  "https://via.placeholder.com/400x300/d9d9d9?text=4:3";
export const SETTING_SUB_ROUTE = { PROFILE: "profile", ACCOUNT: "account" };
export const DEFAULT_PAGE_SIZE = 12;
export const DEBOUNCE_DELAY = 300;
export const ADMIN_PAGESIZE_OPTIONS = [
  {
    id: "5",
    label: "5 per page",
    value: 5,
  },
  {
    id: "10",
    label: "10 per page",
    value: 10,
  },
  {
    id: "25",
    label: "25 per page",
    value: 25,
  },
  {
    id: "50",
    label: "50 per page",
    value: 50,
  },
];
export const COURSE_STATUS = {
  PENDING: 0,
  APPROVE: 1,
  REJECT: 2,
  BLOCK: 3,
};
